<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class=" flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">子机构管理</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="5" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r" v-if="userInfo.institution">
                <div class="top_box">
                    <div class="company_box flex-box">
                        <img :src="userInfo.institution.avatar" class="company_img" alt="" />
                        <div class="flex-grow-1">
                            <div class="flex-box">
                                <div class="company_name fs20 fwb">{{ userInfo.institution.company_name }}</div>
                                <i :class="`vip${userInfo.institution.level}`" v-if="userInfo.institution.level > 0"></i>
                            </div>
                            <div class="fs16 mt5 col90">手机号：{{ userInfo.institution.mobile }}</div>
                        </div>
                    </div>
                </div>
                <div class="bottom_box">
                    <div class="flex-box flex-between fs18">
                        <div class="col10 fwb">下属子机构</div>
                        <div class="flex-box new colf flex-center cursor ml30 fs14"
                            @click="newAddPop = true, getBusiness()">新 增</div>
                    </div>
                    <div class="list_box fs14 mt35" v-if="institutionList.length > 0">
                        <div class="title_box flex-box col04">
                            <div class="box1 tc">机构名称</div>
                            <div class="box2 tc">地区</div>
                            <div class="box3 tc">积分收益</div>
                            <div class="box4 tc">状态</div>
                            <div class="flex-grow-1 tc">操作</div>
                        </div>
                        <div class="address_box flex-box col90" v-for="(item, index) in institutionList" :key="index">
                            <div class="box1 flex-box">
                                <img :src="item.institution.avatar" class="avatar" alt="" />
                                <div class="col04">{{ item.institution.company_name }}</div>
                            </div>
                            <div class="box2 flex-box flex-center col90">{{ item.institution.city.shortname }}</div>
                            <div class="box3 col04">{{ item.institution.score }}</div>
                            <div class="box4 col04">{{ item.institution.status_text }}</div>
                            <div class="flex-grow-1 flex-box flex-center col12">
                                <div class="action cursor" @click="onDel(item.id)">删除</div>
                                <div class="action cursor" @click="toOrder(item.id)">查看订单</div>
                            </div>
                        </div>
                    </div>
                    <pagination :sumCount="sumCount" :perCount="perCount" v-show="sumCount > perCount"></pagination>
                    <div v-if="institutionList.length == 0" class="nodata fs16 tc">
                        <img src="../../../assets/static/icon/c_notitle.png" class="c_nodata" alt="" />
                        <div>您还没有添加下属子机构哦</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <popup :visible="newAddPop" @close="newAddPop = false">
        <div class="add_pop relative bgf br10">
            <div class="title_box">
                <img src="../../../assets/static/icon/c_pop_close.png" class="pop_close cursor" @click="newAddPop = false"
                    alt="" />
                <div class="title fs18 fwb mb25 col12 flex-box ">新增机构 </div>
                <div class="fs14 col12">请完善您的机构资料，以便我们更好地为您提供服务。</div>
            </div>
            <div class="pop_main">
                <div class="progess_part flex-box flex-center">
                    <div class="num_on">1</div>
                    <div class="ml5 fs20 blue lh34">注册信息</div>
                    <div class="line_on mlr5"></div>
                    <div :class="state >= 1 ? 'num_on' : 'num'">2</div>
                    <div class="ml5 fs20 lh34" :class="state >= 1 ? 'blue' : 'cold7d'">认证信息</div>
                    <div class="mlr5" :class="state == 2 ? 'line_on' : 'line'"></div>
                    <div :class="state >= 2 ? 'num_on' : 'num'">3</div>
                    <div class="ml5 fs20 lh34" :class="state >= 2 ? 'blue' : 'cold7d'">证照上传</div>
                    <div class="mlr5" :class="state >= 3 ? 'line_on' : 'line'"></div>
                    <div :class="state >= 3 ? 'num_on' : 'num'">4</div>
                    <div class="ml5 fs20 lh34" :class="state >= 3 ? 'blue' : 'cold7d'">提交审核</div>
                </div>
                <div class="partt">
                    <template v-if="state == 0">
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">联系人：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请填写联系人"
                                        type="text" :value="institution.contact" @input="onInput($event, 'contact')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">联系人职位：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请填写联系人职位"
                                        type="text" :value="institution.contact_job"
                                        @input="onInput($event, 'contact_job')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">联系电话：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请填写联系人电话"
                                        maxlength="11" type="number" :value="institution.mobile"
                                        @input="onInput($event, 'mobile')" />
                                </div>
                            </div>
                        </div>

                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1"> 验证码：</div>
                        </div>
                        <div class="pr fs16">
                            <div class="flex-box">
                                <div :class="isCode ? 'prompt_border1' : ''" class="flex-grow-1">
                                    <div class="part2 part33 flex-grow-1">
                                        <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请输入验证码"
                                            type="number" maxlength="4" :value="institution.code"
                                            @input="onInput($event, 'code')" />
                                    </div>
                                </div>
                                <!-- <button :class=" showseconds ? 'code_btn_on' : 'code_btn'"
                                class="ml15 tc mb30 point fs14" @click="getCode">
                                {{ tips }}
                            </button> -->
                                <button :class="captcha == '获取验证码' || captcha == '重新获取验证码' ? 'code_btn_on' : 'code_btn'"
                                    class="ml15 tc mb30 point" @click="handleCaptcha">
                                    {{ captcha }}
                                </button>
                            </div>
                            <div class="fs18 red lh28 prompt_info" v-if="isCode">验证码错误</div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">登录密码：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="isPassword ? 'prompt_border1' : ''">
                                <div class="part2 flex-box">
                                    <input :type="hide ? 'text' : 'password'" class="flex-grow-1 col27 "
                                        placeholder-class=" cold3" placeholder="请输入登录密码（6-20位数字与字母组合）"
                                        :value="institution.password" @input="onInput($event, 'password')" />
                                    <img @click="hide = !hide" v-if="hide" class="img2 point"
                                        src="../../../assets/static/icon/jxr_login_show.png" alt="" id="eye" />
                                    <img @click="hide = !hide" v-else class="img2 point"
                                        src="../../../assets/static/icon/jxr_login_hide.png" alt="" id="eye" />

                                </div>
                            </div>
                            <div class="fs18 red lh28 prompt_info" v-if="isPassword">密码错误</div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">再次输入密码：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="isPassword ? 'prompt_border1' : ''">
                                <div class="part2 flex-box">
                                    <input :type="hide ? 'text' : 'password'" class="flex-grow-1 col27 "
                                        placeholder-class=" cold3" placeholder="请再次输入密码"
                                        :value="institution.repeat_password" @input="onInput($event, 'repeat_password')" />
                                    <img @click="hide = !hide" v-if="hide" class="img2 point"
                                        src="../../../assets/static/icon/jxr_login_show.png" alt="" id="eye" />
                                    <img @click="hide = !hide" v-else class="img2 point"
                                        src="../../../assets/static/icon/jxr_login_hide.png" alt="" id="eye" />
                                </div>
                            </div>
                            <div class="fs18 red lh28 prompt_info" v-if="isPassword">密码错误</div>
                        </div>
                    </template>
                    <template v-if="state == 1">
                        <div class="flex-box fs16 col3 lh28 mb20 pr ">
                            <div class="flex-grow-1">业务员邀请码：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请输入业务员邀请码"
                                        type="text" v-model="institution.invite_code" />
                                </div>
                            </div>
                        </div>

                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">公司名称：</div>
                        </div>
                        <div class="pr ">
                            <div class="pr fs16">
                                <div :class="companyListShow ? 'company_partt' : ''">
                                    <div class="part2">
                                        <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请输入公司全称"
                                            type="text" v-model="institution.company_name"
                                            @input="onInputCompany($event, 'company_name')" />
                                    </div>
                                </div>
                            </div>
                            <!-- 公司名称搜索弹窗  -->
                            <view v-if="companyListShow" class="commonly_part bg-white">
                                <template v-if="companyList.length > 0">
                                    <div class="partt2 fs16 p15 col96" :class="true ? 'partt2_active' : 'partt2_active'"
                                        v-for="(item, index) in companyList" :key="index" @click="onClickCompany(index)">
                                        {{ item.entName }}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="partt2 fs16 p15 col96">
                                        未匹配到该公司
                                    </div>
                                </template>
                            </view>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">机构类型：</div>
                        </div>
                        <div class="flex-box flex-wrap pl5">
                            <div v-for="(item, index) in businessList" :key="index" @click="chooseBusiness(index, item.id)"
                                class="mb30 flex-box  minw280 point">
                                <img v-if="businessIndex == index" class="login_checked mr10"
                                    src="../../../assets/static/icon/jxr_login_checked.png" alt="" />
                                <img v-else class="login_checked mr10" src="../../../assets/static/icon/jxr_login_check.png"
                                    alt="" />
                                <div class="fs16 col3 lh28 flex-grow-1">
                                    {{ item.name }}
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">营业执照号：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="自动获取"
                                        type="text" :value="institution.license_no"
                                        @input="onInput($event, 'license_no')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">法人代表：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="自动获取"
                                        type="text" :value="institution.legal_person"
                                        @input="onInput($event, 'legal_person')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">企业所在地：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="自动获取"
                                        type="text" :value="institution.company_address"
                                        @input="onInput($event, 'company_address')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">详细地址：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="自动获取"
                                        type="text" :value="institution.address" @input="onInput($event, 'address')" />
                                </div>
                            </div>
                        </div>
                        <div class="line_part"></div>
                        <div class="tc fs18 mb40 col3">收货地址</div>
                        <view class="notice_part fs16 flex-box mb20 plr20 ptb5 ">
                            <img class="icon" src="../../../assets/static/icon/c_wait.png" alt="">
                            <view class="red  ">
                                请填写【营业执照】或【医疗机构职业许可证】中的地址。
                            </view>
                        </view>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">收 件 人：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请输入收件人姓名"
                                        type="text" :value="institution.myaddress_name"
                                        @input="onInput($event, 'myaddress_name')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">联系人手机号：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="请输入联系人手机号码"
                                        maxlength="11" type="number" :value="institution.myaddress_mobile"
                                        @input="onInput($event, 'myaddress_mobile')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">企业所在地：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="自动获取"
                                        type="text" :disabled="true" :value="institution.myaddress"
                                        @input="onInput($event, 'myaddress')" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">详细地址：</div>
                        </div>
                        <div class="pr fs16">
                            <div :class="false ? 'prompt_border1' : ''">
                                <div class="part2">
                                    <input class="flex-grow-1 col27 " placeholder-class=" cold3" placeholder="自动获取"
                                        type="text" :disabled="true" :value="institution.myaddress_detail"
                                        @input="onInput($event, 'myaddress_detail')" />
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="state == 2">
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">业务委托人身份证：</div>
                        </div>
                        <div class="flex flex-between mb20">
                            <upLoad @upSuc="bindUpload($event, 'salesman_idcard_face')">
                                <div class="upload_part1">
                                    <img v-if="institution.salesman_idcard_face" class="imgs"
                                        :src="institution.salesman_idcard_face" alt="">
                                    <img v-else class="imgs" src="../../../assets/static/icon/enroll_upload1.png" alt="">
                                    <div class="btn fs16 colf tc ">
                                        上传正面
                                    </div>
                                </div>
                            </upLoad>
                            <upLoad @upSuc="bindUpload($event, 'salesman_idcard_back')">
                                <div class="upload_part1">
                                    <img v-if="institution.salesman_idcard_back" class="imgs"
                                        :src="institution.salesman_idcard_back" alt="">
                                    <img v-else class="imgs" src="../../../assets/static/icon/enroll_upload2.png" alt="">
                                    <div class="btn fs16 colf  tc ">
                                        上传反面
                                    </div>
                                </div>
                            </upLoad>
                        </div>
                        <div class="fs16 blue mb15"> 请确认您的信息，若有误请点击修改。</div>
                        <div class="flex-box mb50">
                            <div class="flex-box example_part">
                                <div class="p20 br5 flex-box">
                                    <img class="example_img5" src="../../../assets/static/icon/example_img5.png" alt="">
                                    <img class="example_img5" src="../../../assets/static/icon/example_img6.png" alt="">
                                    <img class="example_img5" src="../../../assets/static/icon/example_img7.png" alt="">
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <div class="flex-box flex-end mb20">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        四角完整
                                    </div>
                                </div>
                                <div class="flex-box flex-end mb20">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        亮度均匀
                                    </div>
                                </div>
                                <div class="flex-box flex-end mb20">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        照片清晰
                                    </div>
                                </div>
                                <div class="flex-box flex-end">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        没有遮挡
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">营业执照：</div>
                        </div>
                        <div class="flex flex-between">
                            <upLoad @upSuc="bindUpload($event, 'license_image')">
                                <div v-if="!institution.license_image" class="upload_part2 bg-white mb15">
                                    <img class="icon " src="../../../assets/static/icon/c_add_up.png" alt="">
                                    <div class="tc fs16 colc8 lh30 mb20">
                                        请上传营业执照照片
                                    </div>
                                </div>
                            </upLoad>
                            <upLoad @upSuc="bindUpload($event, 'license_image')">
                                <img v-if="institution.license_image" class="upload_part2 upload_partt bg-white mb15"
                                    :src="institution.license_image" alt="">
                            </upLoad>
                            <img class="upload_part2 upload_partt bg-white mb15"
                                src="../../../assets/static/icon/example_img1.jpg" alt="">
                        </div>
                        <view class="fs14 cold3 lh22 mb15">
                            审核标准:
                        </view>
                        <div class="fs14 lh22  mb90 cold3 mb50">
                            <div class="">
                                1、JPG、JPEG、PNG、PDF格式，大小不超过10M
                            </div>
                            <div class="">
                                2、证件在有效期内
                            </div>
                            <div class="">
                                3、名称、地址、法人/投资人、统一社会信用代码、日期等信息必须清晰完整，一目了然
                            </div>
                            <div class="">
                                4、企业名称、地址、法人、统一社会信用代码等信息与相关许可证一致
                            </div>
                            <div class="">
                                5、证照四角边缘完整，原件或清晰的复印件
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">医疗机构执业许可证 / 诊所备案证明：</div>
                        </div>
                        <div class="flex flex-between">
                            <upLoad v-if="!institution.medical_license_image"
                                @upSuc="bindUpload($event, 'medical_license_image')">
                                <div class="upload_part2 bg-white mb15">
                                    <img class="icon " src="../../../assets/static/icon/c_add_up.png" alt="">
                                    <div class="tc fs16 colc8 lh30 mb20">
                                        请上传执业许可证照片
                                    </div>
                                </div>
                            </upLoad>
                            <upLoad v-else @upSuc="bindUpload($event, 'medical_license_image')">
                                <img :src="institution.medical_license_image"
                                    class="upload_part2 upload_partt bg-white mb15" alt="">
                            </upLoad>
                            <img class="upload_part2 upload_partt bg-white mb15"
                                src="../../../assets/static/icon/example_img2.jpg" alt="">
                        </div>
                        <view class="fs14 cold3 lh22 mb15">
                            审核标准:
                        </view>
                        <div class="fs14 lh22  mb90 cold3 mb50">
                            <div class="">
                                1、JPG、JPEG、PNG、PDF格式，大小不超过10M
                            </div>
                            <div class="">
                                2、原件或清晰的复印件
                            </div>
                            <div class="">
                                3、证件在有效期内
                            </div>
                            <div class="">
                                4、机构名称、地址、法人/负责人、登记号、日期、发证机关等信息必须清晰完整一目了然
                            </div>
                            <div class="">
                                5、证照四角边缘完整
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">法人身份证：</div>
                        </div>
                        <div class="flex flex-between mb20">
                            <upLoad @upSuc="bindUpload($event, 'idcard_face')">
                                <div class="upload_part1">
                                    <img v-if="institution.idcard_face" class="imgs" :src="institution.idcard_face" alt="">
                                    <img v-else class="imgs" src="../../../assets/static/icon/enroll_upload1.png" alt="">
                                    <div class="btn fs16 colf tc ">
                                        上传正面
                                    </div>
                                </div>
                            </upLoad>
                            <upLoad @upSuc="bindUpload($event, 'idcard_back')">
                                <div class="upload_part1">
                                    <img v-if="institution.idcard_back" class="imgs" :src="institution.idcard_back" alt="">
                                    <img v-else class="imgs" src="../../../assets/static/icon/enroll_upload2.png" alt="">
                                    <div class="btn fs16 colf  tc ">
                                        上传反面
                                    </div>
                                </div>
                            </upLoad>
                        </div>
                        <div class="fs16 blue mb15"> 请确认您的信息，若有误请点击修改。</div>
                        <div class="flex-box mb50">
                            <div class="flex-box example_part">
                                <div class="p20 br5 flex-box">
                                    <img class="example_img5" src="../../../assets/static/icon/example_img5.png" alt="">
                                    <img class="example_img5" src="../../../assets/static/icon/example_img6.png" alt="">
                                    <img class="example_img5" src="../../../assets/static/icon/example_img7.png" alt="">
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <div class="flex-box flex-end mb20">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        四角完整
                                    </div>
                                </div>
                                <div class="flex-box flex-end mb20">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        亮度均匀
                                    </div>
                                </div>
                                <div class="flex-box flex-end mb20">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        照片清晰
                                    </div>
                                </div>
                                <div class="flex-box flex-end">
                                    <div class=" mr10 circle"></div>
                                    <div class="fs14 col27 ">
                                        没有遮挡
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-box fs16 col3 lh28 mb20 pr pl20">
                            <div class="required_tips"></div>
                            <div class="flex-grow-1">法人委托书：</div>
                            <!-- <div class="cursor btn1">下载示例</div> -->
                        </div>
                        <div class="flex flex-between">
                            <upLoad v-if="!institution.legal_authorization_image"
                                @upSuc="bindUpload($event, 'legal_authorization_image')">
                                <div class="upload_part2 upload_part5  bg-white mb15">
                                    <img class="icon " src="../../../assets/static/icon/c_add_up.png" alt="">
                                    <div class="tc fs16 colc8 lh30 mb20">
                                        请上传法人委托书照片
                                    </div>
                                </div>
                            </upLoad>
                            <upLoad v-else @upSuc="bindUpload($event, 'legal_authorization_image')">
                                <img :src="institution.legal_authorization_image"
                                    class="upload_part2 upload_partt bg-white mb15" alt="">
                            </upLoad>
                            <div class="pr w304">
                                <img class="upload_part2 upload_part5 upload_partt bg-white mb15"
                                src="../../../assets/static/icon/example_img3.jpg" alt="">
                            <div @click="downloadAuthorizationExample()" class="btn_d cursor">下载模板</div>
                        </div>
                        </div>
                        <view class="fs14 cold3 lh22 mb15">
                            审核标准:
                        </view>
                        <div class="fs14 lh22  mb90 cold3 ">
                            <div class="">
                                1、JPG、JPEG、PNG、PDF格式
                            </div>
                            <div class="">
                                2、法定代表人须手写签字或盖章，以许可证上的法定代表人为准，如为非法人企业则由企业负责人签字授权
                            </div>
                            <div class="">
                                3、填写单位全称、采购员姓名、身份证号、手机号、委托期限、签署日期
                            </div>
                            <div class="">
                                4、委托期限可跨年，但不得超过两年
                            </div>
                            <div class="">
                                5、委托书不得带供应商抬头
                            </div>
                            <div class="">
                                6、证照四角边缘完整清晰
                            </div>
                        </div>
                        <div class="line_part"></div>
                        <div class="tc fs18 mb40">其它资质补充</div>
                        <div class="fs16 blue mb30">(选择您拥有的资质证件并上传，可多选)</div>
                        <div v-for="(other, index) in others" :key="index" class="">
                            <div :class="other.checked ? 'mb50' : 'mb25'" class="flex-box " @click="tapInfo(index)">
                                <div class="flex-grow-1 fs18 col27 lh36">
                                    {{ other.title }}
                                </div>
                                <img class="checked_icon point" v-if="other.checked"
                                    src="../../../assets/static/icon/c_check2-on.png" alt="">
                                <img class="checked_icon point" v-else src="../../../assets/static/icon/c_check2.png"
                                    alt="">
                            </div>
                            <div class="tc" v-if="other.checked">
                                <upLoad v-if="!other.image" @upSuc="bindOtherUpload($event, index)">
                                    <div class="upload_part3  mb30">
                                        <img class="icon " src="../../../assets/static/icon/c_add_up.png" alt="">
                                        <div class="tc fs16 colc8 lh30 ">
                                            {{ other.title }}
                                        </div>
                                    </div>
                                </upLoad>
                                <upLoad v-else @upSuc="bindOtherUpload($event, index)">
                                    <img class="upload_part3 upload_partt bg-white mb30" :src="other.image"
                                        mode="aspectFill">
                                </upLoad>

                            </div>
                        </div>
                    </template>
                    <div v-if="state == 0" class="flex-box lh52" @click="agreementArticle">
                        <img v-if="check" class="login_checked point mr15"
                            src="../../../assets/static/icon/jxr_login_checked.png" alt="" />
                        <img v-else class="login_checked point mr15" src="../../../assets/static/icon/jxr_login_check.png"
                            alt="" />
                        <div class="fs16 col3">
                            我已阅读并同意
                            <span class="blue point" @click.stop="onAgreement(1)">《用户协议》</span>
                            <span class="blue point" @click.stop="onAgreement(2)">《隐私政策》</span>
                        </div>
                    </div>
                    <button v-if="state < 2"
                        :class="(state == 0 && nextStatus0) || (state == 1 && nextStatus1) ? 'btn_login_on' : 'btn_login'"
                        class="point"
                        @click="(state == 0 && nextStatus0) || (state == 1 && nextStatus1) ? onNext() : ''">下一步</button>
                    <div v-if="state == 2" class="flex-box flex-between">
                        <button class="point flex-grow-1 " style="margin-right: 10px"
                            :class="true ? 'btn_login_on' : 'btn_login_on'" @click="onPrev">上一步</button>
                        <button class="point  flex-grow-1" style="margin-left: 10px"
                            :class="saveStatus ? 'btn_login_on' : 'btn_login'"
                            @click="saveStatus ? onSave() : ''">提交审核</button>
                    </div>

                    <div class="tc lh52 mt65 fs16 col3">遇到问题？请<span class="point blue" @click="telContact">联系客服</span>
                    </div>
                </div>

            </div>

        </div>
    </popup>
    <popup :visible="popShow" @close="popShow = false">
        <div class="intro_pop">
            <img src="../../../assets/static/icon/c_pop_close.png" class="c_pop_close" @click="popShow = false" alt="" />
            <div class="article">
                <img src="../../../assets/static/icon/c_success.png" class="c_success" alt="" />
                <div class="fs22 col04 tc mb15">提交成功</div>
                <div class="fs16 col90 tc">您的机构资质已提交，请等待后台审核。</div>
            </div>
        </div>
    </popup>
    <!--《用户协议》弹窗  -->
    <popup :visible="sucPop" @close="sucPop = false">
        <div class="popup">
            <div class="tc fs24 col3 tc lh34 mb45">《用户协议》</div>
            <div class="line2"></div>
            <div class="popup_main" v-html="agreement1"></div>
            <div @click="sucPop = false" class="fs16 col3 tc close_btn cursor">关闭</div>
        </div>
    </popup>
    <!-- 《隐私政策》弹窗 -->
    <popup :visible="sucPop2" @close="sucPop2 = false">
        <div class="popup">
            <div class="tc fs24 col3 tc lh34 mb45">《隐私政策》</div>
            <div class="line2"></div>
            <div class="popup_main" v-html="agreement2"></div>
            <div @click="sucPop2 = false" class="fs16 col3 tc close_btn cursor">关闭</div>
        </div>
    </popup>
    <!-- 审核 -->
    <popup :visible="shPop" @close="checkPopHide">
        <div class="shPop">
            <img class="bj" src="../../../assets/static/icon/jxr_sucess.png" alt="">
            <div class="info">
                <img @click="checkPopHide" class="close point" src="../../../assets/static/icon/jj_popup_close.png" alt="">
                <div class="tc fs22 mb10">信息已提交，请耐心等待审核</div>
                <div class="fs16 tc col90 tc">（审核通过将在2-3个工作日内短信通知）</div>
            </div>
        </div>
    </popup>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import upLoad from "../../../components/UploadFormat.vue";
import * as com from '@/utils/common.js'; // 导入公共方法
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
import validate from "../../../utils/validate.js";
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "子机构管理-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
        upLoad
    },
    data() {
        return {
            newAddPop: false,

            captcha: "获取验证码",
            totalTime: 60,
            canClick: true, // 节流
            clockTimer: null, // 定时器

            showseconds: false,
            hide: false, //显示隐藏密码
            show: false, //审核弹窗

            showPwd: false,
            state: 0,
            imageUrl: '',
            popShow: false,
            userInfo: {},
            institutionList: [],//机构列表

            isCode: false,
            isPassword: false,
            isRepeatPassword: false,

            companyIndex: 0,
            companyList: [
                // '上海小狮优选信息科技发展有限公司', '上海小狮优选信息科技发展有限公司', '上海小狮优选信息科技发展有限公司', '上海小狮优选信息科技发展有限公司', '上海小狮优选信息科技发展有限公司',
                // '上海小狮优选信息科技发展有限公司'
            ],
            companyListShow: false,

            businessList: [],
            businessIndex: -1,
            sumCount: 0,
            perCount: 10,
            // 

            nextStatus0: false,
            nextStatus1: false,
            saveStatus: false,
            check: false,
            checkStatus: false,

            institution: {
                contact: '',
                contact_job: '',
                mobile: '',
                code: '',
                password: '',
                repeat_password: '',

                invite_code: '',
                company_name: '',
                business_ids: [],
                license_no: '',
                legal_person: '',
                province: '',
                province_id: 0,
                city: '',
                city_id: 0,
                district: '',
                district_id: 0,
                company_address: '',
                address: '',
                myaddress_name: '',
                myaddress_mobile: '',
                myaddress: '',
                myaddress_detail: '',

                salesman_idcard_face: '',
                salesman_idcard_back: '',
                license_image: '',
                medical_license_image: '',
                idcard_face: '',
                idcard_back: '',
                legal_authorization_image: '',
                tax_no: '',
                expire_start: '',
                expire_end: '',
                medical_license_no: '',
                medical_expire_start: '',
                medical_expire_end: '',
                legal_no: '',
                idcard_start: '',
                idcard_end: '',
                business_scope: ''
            },
            others: [
                { title: '全麻资质', image: '', checked: false },
                { title: '麻醉药品购用印签卡', image: '', checked: false },
                { title: '第一类精神药品购用印签卡', image: '', checked: false },
            ],
            rule0: [{
                name: 'contact',
                nameChn: '联系人',
                rules: ['require'],
                errorMsg: {
                    require: '请填写联系人'
                }
            },
            {
                name: 'contact_job',
                nameChn: '联系人职位',
                rules: ['require'],
                errorMsg: {
                    require: '请填写联系人职位'
                }
            },
            {
                name: 'mobile',
                nameChn: '手机号',
                rules: ['require', 'mobile'],
                errorMsg: {
                    require: '请填写手机号',
                    mobile: '请填写正确的手机号'
                }
            },
            {
                name: 'code',
                nameChn: '验证码',
                rules: ['require', 'length:4'],
                errorMsg: {
                    require: '请填写验证码',
                    length: '请填写4位验证码'
                }
            },
            {
                name: 'password',
                nameChn: '新密码',
                rules: ['require', 'min:6'],
                errorMsg: {
                    require: '请填写新密码',
                    min: '密码至少6位'
                }
            },
            {
                name: 'repeat_password',
                nameChn: '再次输入密码',
                rules: ['require', 'identical:password'],
                errorMsg: {
                    require: '请填写新密码',
                    identical: '两次密码不一致'
                }
            },
            ],
            rule1: [{
                name: 'company_name',
                nameChn: '公司名称',
                rules: ['require'],
                errorMsg: {
                    require: '请填写公司名'
                }
            },
            {
                name: 'license_no',
                nameChn: '营业执照号',
                rules: ['require'],
                errorMsg: {
                    require: '请填写营业执照号'
                }
            },
            {
                name: 'legal_person',
                nameChn: '法人代表',
                rules: ['require'],
                errorMsg: {
                    require: '请填写法人代表'
                }
            },
            {
                name: 'company_address',
                nameChn: '企业所在地',
                rules: ['require'],
                errorMsg: {
                    require: '请填写企业所在地'
                }
            },
            {
                name: 'address',
                nameChn: '详细地址',
                rules: ['require'],
                errorMsg: {
                    require: '请填写详细地址'
                }
            },
            {
                name: 'myaddress_name',
                nameChn: '收件人',
                rules: ['require'],
                errorMsg: {
                    require: '请填写收件人'
                }
            },
            {
                name: 'myaddress_mobile',
                nameChn: '收货电话',
                rules: ['require', 'mobile'],
                errorMsg: {
                    require: '请填写联系方式',
                    mobile: '手机格式错误',
                }
            },
            ],
            rule2: [
                {
                    name: 'salesman_idcard_face',
                    nameChn: '身份证正面',
                    rules: ['require'],
                    errorMsg: {
                        require: '请上传委托人身份证正面'
                    }
                },
                {
                    name: 'salesman_idcard_back',
                    nameChn: '身份证背面',
                    rules: ['require'],
                    errorMsg: {
                        require: '请上传委托人身份证背面'
                    }
                },
                {
                    name: 'license_image',
                    nameChn: '营业执照',
                    rules: ['require'],
                    errorMsg: {
                        require: '请上传营业执照'
                    }
                },
                {
                    name: 'medical_license_image',
                    nameChn: '执照许可证',
                    rules: ['require'],
                    errorMsg: {
                        require: '请上传执照许可证'
                    }
                },
                {
                    name: 'idcard_face',
                    nameChn: '身份证正面',
                    rules: ['require'],
                    errorMsg: {
                        require: '请上传身份证正面'
                    }
                },
                {
                    name: 'idcard_back',
                    nameChn: '身份证背面',
                    rules: ['require'],
                    errorMsg: {
                        require: '请上传身份证背面'
                    }
                },
                {
                    name: 'legal_authorization_image',
                    nameChn: '法人委托书',
                    rules: ['require'],
                    errorMsg: {
                        require: '请上传法人委托书'
                    }
                },
            ],
            fields0: [
                'contact', 'contact_job', 'mobile', 'code', 'password', 'repeat_password',
            ],
            fields1: [
                'company_name', 'license_no', 'legal_person', 'city', 'address',
                'myaddress_name', 'myaddress_mobile', 'myaddress', 'myaddress_detail'
            ],
            fields2: [
                'salesman_idcard_face', 'salesman_idcard_back', 'license_image',
                'medical_license_image', 'idcard_face', 'idcard_back', 'legal_authorization_image'
            ],
            agreement1: '',//用户协议 隐私政策
            agreement2: '',//用户协议 隐私政策
            sucPop: false,
            sucPop2: false,
            shPop: false,
        };
    },
    created() {
        this.getUserInfo();
        this.getInstitution();
    },
    computed: {

    },
    beforeUnmount() {
        this.newAddPop = false;
        this.shPop = false;
    },
    methods: {
        // 订单页面
        toOrder(id) {
            this.$router.push({ path: "/SubOrder", query: { id: id } });
        },
        // 获取用户信息
        getUserInfo() {
            let that = this;
            that.$api.GetUserInfo().then(res => {
                if (res.code == 1) {
                    that.userInfo = res.data;
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取子机构
        getInstitution(page) {
            let that = this;
            that.$api.getInstitution({
                page: page,
            }).then(res => {
                if (res.code == 1) {
                    that.institutionList = res.data.data;
                    that.sumCount = res.data.total;
                    that.perCount = res.data.per_page;
                }
            })
        },
        // 删除子机构
        onDel(id) {
            this.$confirm('确认删除此机构吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delInstitution({ id: id }.then(res => {
                    if (res.code == 1) {
                        this.$message({
                            customClass: 'custom-message',
                            message: '删除成功',
                            type: 'success',
                            duration: 3000,
                        })
                    }
                })).catch(err => {
                    console.log(err);
                })
            }).catch(() => {
                console.log('取消删除');
            });

        },
        // 获取机构类型
        getBusiness() {
            let that = this;
            that.$api.getBusiness().then(res => {
                that.businessList = res.data;
            })
        },
        // 获取验证码
        handleCaptcha() {
            let that = this;
            if (!that.canClick) return; // 节流 防止频繁访问接口
            if (com.checkPhone(that.institution.mobile)) {
                that.canClick = false;
                that.captcha = that.totalTime + "s后重新发送";
                that.clockTimer = window.setInterval(() => {
                    that.totalTime--;
                    that.captcha = that.totalTime + "s后重新发送";
                    if (that.totalTime < 0) {
                        window.clearInterval(that.clockTimer);
                        that.captcha = "重新发送验证码";
                        that.totalTime = 60;
                        that.canClick = true;
                    }
                }, 1000);
                that.$api.getCode({
                    mobile: that.institution.mobile,
                    event: 'register'
                });
            } else {
                that.$message.error("手机号错误")
            }
        },
        clickhide() {
            this.hide = !this.hide
        },
        tapInfo(index) {
            this.others[index].checked = !this.others[index].checked;
        },
        // 选择机构
        chooseBusiness(index, id) {
            this.businessIndex = index;
            this.institution.business_ids = [id];
        },
        downloadAuthorizationExample(){
            window.location.href = this.$root.$data.config.app.legal_authorization_example
        },

        onInputCompany(event, field) {
            let companyName = this.institution.company_name;
            if (companyName.length >= 6) {
                this.$api.Getbusinesslike({ company_name: companyName }).then(res => {
                    this.companyList = res.data;
                    this.companyListShow = true;
                })
            }else{
                this.companyList = [];
                this.companyListShow = false;
            }

        },
        //选择某个公司
        onClickCompany(index) {
            let page = this;
            let companyName = this.companyList[index].entName;
            this.$api.Getbusinessdetail({ company_name: companyName }).then(ret => {
                this.institution.company_name = ret.data.companyName;
                this.institution.license_no = ret.data.creditNo;
                this.institution.expire_start = ret.data.operationStartdate;
                this.institution.expire_end = ret.data.operationEnddate;
                this.institution.legal_person = ret.data.legalPerson;
                this.institution.company_address = ret.data.province + ret.data.city + ret.data.district;
                this.institution.address = ret.data.companyAddress;
                this.institution.province = ret.data.province;
                this.institution.city = ret.data.city;
                this.institution.district = ret.data.district;
                this.institution.myaddress = ret.data.province + ret.data.city + ret.data.district;
                this.institution.myaddress_detail = ret.data.companyAddress;
                this.institution.business_scope = ret.data.businessScope
                this.checkSaveStatus();
                this.companyListShow = false;
            })
        },
        //input框输入
        onInput(event, field) {
            this.institution[field] = event.target.value;
            this.checkSaveStatus()
        },
        checkSaveStatus() {
            let checkFields = this['fields' + this.state];
            let max_len = checkFields.length,
                len = 0;
            for (let i in this.institution) {
                //console.log(i,this.institution[i])
                if (checkFields.indexOf(i) !== -1 && this.institution[i]) {
                    len++;
                }
            }
            //console.log(checkFields,len,max_len)
            if (this.state <= 1) {
                this['nextStatus' + this.state] = len == max_len ? true : false;
            } else {
                this.saveStatus = len == max_len ? true : false;
            }
        },
        //图片上传
        bindUpload(event, field) {
            this.institution[field] = event.url;
            this.checkSaveStatus();
        },
        //其他资质上传
        bindOtherUpload(event, index2) {
            let page = this;
            page.others[index2].image = event.url;
        },
        //同意协议
        agreementArticle() {
            this.check = !this.check;
        },
        //用户协议与隐私政策
        onAgreement(type) {
            let id = type == '1' ? this.$root.$data.config.app.user_agreement
                : this.$root.$data.config.app.privacy_agreement;
            let that = this;
            that.$api.getAgreement({ id: id }).then(res => {
                if (type == 1) {
                    that.agreement1 = res.data.content;
                    that.sucPop = true;
                } else {
                    that.agreement2 = res.data.content;
                    that.sucPop2 = true;
                }

            })
        },

        onPrev() {
            this.state = this.state - 1
        },
        //关闭页面
        checkPopHide() {
            this.shPop = false;
            this.newAddPop = false;
            this.getInstitution(1);
        },

        telContact() {
            this.newAddPop = false;
            this.$router.push("/CustomerSer")
        },

        /**
         * 提交表单检测
         * page 当前对象
         * formData 要检测的数据
         * rule 检测规则
         * onlyshowToast: 是否需要设置错误状态
         */
        async checkValidate(page, formData = {}, rule, onlyshowToast = true) {
            let data;
            let that = this;
            data = await (new Promise(function (resolve, reject) {
                // 是否全部通过，返回Boolean
                if (!validate.check(formData, rule)) {
                    let errors = validate.getError();
                    if (!onlyshowToast) {
                        let errorFields = [];
                        errors.forEach(item => errorFields.push(item.name))
                        for (let i in page.errorStatus) {
                            page.errorStatus[i] = errorFields.indexOf(i) !== -1 ? true : false;
                        }
                    }
                    that.$message.error(errors[0].msg);
                    if (errors.length == 0) {
                        resolve([]);
                    } else {
                        reject(errors);
                    }

                } else {
                    resolve([]);
                }
            }));
            return data;
        },

        onNext() {
            if (this.state == 0 && !this.check) {
                this.$message.error("请先同意协议");
                return;
            }
            let rules = this['rule' + this.state];
            let institution = this.institution;
            institution.step = this.state;
            this.checkValidate(this, institution, rules, false).then(res => {
                this.$api.CheckCode(institution).then(ret => {
                    if (this.state == 1) {
                        this.institution.province_id = ret.data.province_id;
                        this.institution.city_id = ret.data.city_id;
                        this.institution.district_id = ret.data.district_id;
                    }
                    this.state = this.state + 1; //下一步
                })
            })
        },
        onSave() {
            let institution = this.institution;
            institution.others = this.others;
            this.checkValidate(this, institution, this.rule2, false).then(res => {
                this.$api.addInstitution(institution).then(res => {
                    this.state = 3;
                    this.shPop = true
                })

            })
        },
    },
};
</script>

<style lang="less" scoped>
.w100 {
    width: 100vw;
}
.part_r {
    .top_box {
        width: 100%;
        background: #fff;
        margin-bottom: 10px;

        .company_box {
            height: 214px;
            padding-left: 52px;

            .company_img {
                width: 100px;
                height: 100px;
                display: block;
                margin-right: 20px;
                border-radius: 50%;
                object-fit: cover;
            }

            .company_name {
                color: #272727;
                letter-spacing: 1.2px;
            }

            i {
                width: 135px;
                height: 60px;
                display: block;
                background-repeat: no-repeat;
                background-size: 100%;
                background-position: center;

                &.vip1 {
                    background-image: url("/src/assets/static/icon/c_vip1.png");
                }

                &.vip2 {
                    background-image: url("/src/assets/static/icon/c_vip2.png");
                }

                &.vip3 {
                    background-image: url("/src/assets/static/icon/c_vip3.png");
                }
            }
        }

    }

    .bottom_box {
        padding: 37px 44px 164px;
        background: #fff;
    }

    .new {
        width: 108px;
        height: 44px;
        border-radius: 6px;
        background: #1275ff;

        &::before {
            display: block;
            content: "";
            width: 18px;
            height: 18px;
            display: block;
            margin-right: 8px;
            background: url('/src/assets/static/icon/c_add_new.png') no-repeat center;
            background-size: 100%;
        }
    }

    .title_box {
        height: 50px;
        background: #fafcff;
    }

    .address_box {
        height: 136px;
        border-bottom: 1px solid #c0cfdd;
    }

    .box1 {
        width: 381px;
        padding-left: 85px;

        .avatar {
            width: 66px;
            height: 66px;
            background: #FFFFFF;
            border-radius: 33px;
            border: 3px solid rgba(98, 134, 171, 0.2);
            display: block;
            margin-right: 20px;
            object-fit: cover;
            border-radius: 50%;
        }
    }

    .box2 {
        width: 158px;


    }

    .title_box {
        .box1 {
            padding-left: 0;
        }
    }

    .address_box {
        .box2 {
            &::before {
                content: "";
                display: block;
                background: url('/src/assets/static/icon/c_location.png') no-repeat center;
                width: 17.5px;
                height: 20px;
                background-size: 100%;
                margin-right: 9px;
            }
        }
    }

    .box3 {
        width: 150px;
        text-align: center;
    }

    .box4 {
        width: 150px;
        text-align: center;
    }

    .action {
        font-weight: 400;
        color: #1275FF;
        text-decoration-line: underline;
        margin: 0 12.5px;
    }
}

.add_pop {
    width: 800px;

    .underline {
        margin-left: 230px;
        font-weight: normal;
    }

    .form_box {
        .input {
            width: 100%;
        }

        .warning {
            .input {
                border-color: #ed1515;
            }

            .prompt_info {
                position: absolute;
                left: 0;
                bottom: -25px;
            }
        }

        .input.code {
            width: 430px;
        }

        .get_code {
            width: 144px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background: #1275FF;
            border-radius: 6px;
            margin-left: 24px;


        }

        .code_btn {
            background: #c2c2c2;
        }

        .sure.unable {
            background: #bdd3ff;
        }

        .sub_type {
            &::before {
                content: "";
                display: block;
                width: 20px;
                height: 20px;
                background: url('../../../assets/static/icon/c_check2.png') no-repeat center;
                background-size: 100%;
                margin-right: 10px;
            }

            &.active::before {
                background-image: url('../../../assets/static/icon/c_check2-on.png');
            }
        }

        .half {
            width: 280px;
        }

        .up_box {
            width: 280px;
            height: 166px;
            border-radius: 8px;
            border: 2px solid rgba(98, 134, 171, 0.2);
            position: relative;
            overflow: hidden;

            .up_load {
                width: 55px;
                height: 50px;
                background: url('../../../assets/static/icon/c_add_up.png') no-repeat center;
                background-size: 100%;
                margin: 0 auto 8px;
                display: block;
            }

            .close_icon {
                width: 20px;
                height: 20px;
                display: block;
                object-fit: contain;
                position: absolute;
                z-index: 2;
                top: 8px;
                right: 8px;
                cursor: pointer;
            }

            .up_img {
                width: 276px;
                height: 162px;
                object-fit: cover;
                position: relative;
                z-index: 1;
            }
        }

        .input {

            .input_time {
                width: 100%;
                height: 48px;
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                cursor: pointer;
            }

            div {
                height: 48px;
                line-height: 48px;
            }

        }
    }
}

.intro_pop {
    background: url('/src/assets/static/icon/c_intro_bg3.png') no-repeat center;
    width: 422px;
    height: 343px;
    padding-top: 37px;
    background-size: 422px 343px;

    .c_success {
        width: 66px;
        height: 66px;
        display: block;
        margin: 72px auto 25px;
    }
}

.nodata {
    padding-top: 110px;
    height: 380px;
    color: #c9cdd4;

    .c_nodata {
        width: 263px;
        height: 166px;
        display: block;
        margin: 0 auto;
    }
}

.pop_main {
    width: 100%;

    .colc8 {
        color: #c8c8c8;
    }

    .cold7d {
        color: #d7d4d4;
    }

    .col-36 {
        color: #363636;
    }

    .col36 {
        color: #363636;
    }

    .progess_part {
        padding: 35px 0px;
        border-bottom: 1px solid #e6e6e6;
    }

    .progess_part .num_on,
    .progess_part .num {
        width: 28px;
        height: 28px;
        background: #ffd040;
        text-align: center;
        line-height: 28px;
        border-radius: 50%;
        overflow: hidden;
        font-size: 20px;
        color: #ffffff;
        margin-right: 5px;
    }

    .progess_part .num {
        background: #e6e6e6;
    }

    .progess_part .line_on,
    .progess_part .line {
        width: 50px;
        height: 0px;
        border-top: 1px dashed #3d7efe;
    }

    .progess_part .line {
        border-color: #d7d4d4;
    }

    .partt {
        width: 660px;
        margin: 0 auto;
        padding-top: 30px;
    }

    .bg-white {
        background: #fff;
    }

    .point {
        cursor: pointer;
    }

    .bg_f9 {
        background: #f9f9f9;
    }

    .head_part {
        width: 1400px;
        margin: 0 auto;
        padding: 66px 0;
    }

    .login_logo {
        width: 220px;
        display: block;
        object-fit: contain;
    }

    .line {
        width: 1px;
        height: 45px;
        background: #979797;
    }

    .pr {
        position: relative;
    }

    .z3 {
        z-index: 3;
    }

    .part2 {
        width: 660px;
        height: 60px;
        margin: 0 auto 30px;
        border-radius: 8px;
        overflow: hidden;
        border-radius: 8px;
        border: 1px solid #cccccc;
        padding-left: 16px;
    }

    .part2 .img1 {
        width: 28px;
        height: 28px;
        display: block;
        object-fit: contain;
        margin-right: 12px;
    }

    .part2 .img2 {
        width: 24px;
        height: 24px;
        display: block;
        object-fit: contain;
        margin-right: 16px;
    }

    .part2 input {
        width: 100%;
        height: 100%;
        line-height: 100%;
    }

    .prompt_border1 {
        width: 660px;
        height: 66px;
        // border: 2px solid #ffd4d4;
        border-radius: 11px;
        margin: 0 auto 30px;
    }

    .prompt_border1 .part2 {
        // width: 100%;
        // height: 100%;
        border-color: #ed1515;
    }

    .prompt_border1 .part33 {
        width: 100%;
    }

    .prompt_border1 .part33 {
        width: 100%;
    }

    .part33 {
        width: 100%
    }

    .code_btn_on,
    .code_btn {
        width: 176px;
        height: 60px;
        line-height: 60px;
        background: #3d7efe;
        border-radius: 6px;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
    }

    .code_btn {
        background: #c2c2c2;
    }

    .login_checked {
        width: 22px;
        height: 22px;
        display: block;
        object-fit: contain;
    }

    .btn_login_on,
    .btn_login {
        border: none;
        margin: 92px auto 0;
        font-size: 18px;
        color: #fff;
        font-weight: 500;
        text-align: center;
        width: 660px;
        height: 60rpx;
        line-height: 60px;
        border-radius: 8px;
        background: #3d7efe;
    }

    .btn_login {
        background: #bdd3ff;
    }

    .blue {
        color: #3d7efe;
    }

    .cold7d {
        color: #d7d4d4;
    }

    .col36 {
        color: #363636;
    }

    .mt65 {
        margin-top: 65px;
    }

    .minw280 {
        width: 33%;
    }

    .line_part {
        widows: 100%;
        height: 1px;
        background: #d8d8d8;
        margin: 54px 0 35px;
    }


    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 99;
        top: 0;
        left: 0;
        background: transparent;
    }

    .company_partt {
        border-radius: 8px;
        border: 1px solid #3F7FFE;
    }

    .commonly_part {
        position: absolute;
        left: 0px;
        top: 61px;
        z-index: 999;
        width: calc(100% + 0px);
        height: 220px;
        overflow-y: scroll;
        box-shadow: 0px 4px8px 0px #DFE5EF;
        border-radius: 0 0 8px 8px;
        border-left: 1px solid #3F7FFE;
        border-right: 1px solid #3F7FFE;
        border-bottom: 1px solid #3F7FFE;

        .partt2 {
            display: block;
        }

        .partt2_active {
            background: rgba(61, 126, 254, 0.1);
        }

        .active {
            background: #F4F5F7;
        }
    }

    .example_part {
        width: 537px;
        background: #F4F5F7;
        border-radius: 2px;
    }

    .example_img5 {
        width: 140px;
        height: auto;
        display: block;
        margin-right: 30px;
    }

    .example_img5:last-of-type {
        margin-right: 0;
    }





    .line2 {
        width: 1160px;
        height: 1px;
        background: repeating-linear-gradient(to right,
                rgba(51, 51, 51, 0),
                rgba(51, 51, 51, 1),
                rgba(51, 51, 51, 0));
        margin: 0 auto 45px;
    }

    .popup_main {
        height: 50vh;
        overflow-y: scroll;
        margin: 0 auto 77px;
    }

    .notice_part {
        background: #fef4f2;
        border-radius: 4px;

        .icon {
            width: 20px;
            height: auto;
            display: block;

            margin-right: 10px;
        }

        .col-red {
            color: #eb3f25;
        }
    }

    .upload_part1 {
        border-radius: 2px;
        overflow: hidden;

        .imgs {
            width: 320px;
            height: 217px;
            display: block;
            border-radius: 2px 2px 0 0;
            border: 1px solid #ccc;
            overflow: hidden;
        }

        .btn {
            height: 45px;
            line-height: 45px;
            background: #3F7FFE;
        }
    }

    .upload_part2 {
        width: 320px;
        height: 196px;
        border-radius: 4px;
        border: 1px solid #ccc;
        padding-top: 50px;

        .icon {
            width: 60px;
            height: 54px;
            display: block;
            margin: 0 auto 24px;
        }
    }

    .upload_part5 {
        height: 304px;
        padding-top: 99px;
    }

    .checked_icon {
        width: 20px;
        height: 20px;
        display: block;
    }
    .w304{  height: 304px;}
.btn_d{
    width:100%;
        font-size: 16px;
        color: #fff;
        text-align: center;
        height: 45px;
        line-height: 45px;
        position: absolute;
        z-index: 2;
        left: 0;
        bottom: 0px;
        background: rgba(18, 117, 255, 1);
    }

    .upload_part3 {
        width: 450px;
        height: 224px;
        border-radius: 4px;
        border: 1px solid #ccc;
        padding-top: 57px;
        margin: 0 auto 30px !important;

        .icon {
            width: 72px;
            height: 65px;
            display: block;
            margin: 0 auto 24px;
        }
    }

    .previous_btn,
    .submit_btn,
    .submit_btn_on {
        width: 340px;
        text-align: center;
        height: 96px;
        line-height: 96px;
        border-radius: 20px;
        background: #f4f5f7;
    }

    .previous_btn {
        border: 2px solid #1275FF;
        line-height: 92px;
    }

    .submit_btn {
        background: #BDD3FF;
    }

    .submit_btn_on {
        background: #1275FF;
    }

    .col-c2 {
        color: #c2c2c2;
    }

    .pop2 {
        width: 650px;
        padding-bottom: 84px;
        background: #F4F5F7;

        .icon {
            width: 140px;
            height: 140px;
            display: block;
            margin: 0 auto 50px;
        }
    }

    .pop3 {
        padding: 40px 24px 0;
        background: #F4F5F7;
        border-radius: 28px 28px 0 0;

        .close {
            width: 30px;
            height: 30px;
            display: block;
            position: absolute;
            top: 22px;
            right: 24px;
            z-index: 3;
        }

        .imgs1 {
            width: 540px;
            height: 366px;
            display: block;
            margin: 0 auto 26px;
        }

        .imgs2 {
            width: 540px;
            height: 568px;
            display: block;
            margin: 0 auto 28px;
        }

    }

    .w258 {
        width: 258px;
        margin: 0 auto 30px;
    }

    .imgs4 {
        width: 450px;
        height: 308px;
        display: block;
    }

    .circle {
        width: 10px;
        height: 10px;
        border: 1px solid #3F7FFE;
        border-radius: 50%;
        position: relative;
    }

    .circle::after {
        content: '';
        display: block;
        width: 5px;
        height: 5px;
        background: #3F7FFE;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%)translateY(-50%);
        z-index: 2;
    }

    .upload_partt {
        padding-top: 0;
    }

}

.popup {
    width: 1400px;
    padding: 106px 120px 80px;
    background: #ffffff;
    box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.23);
    border-radius: 20px;
    width: 70vw;
    max-height: 80vh;
    overflow-y: scroll;

    .close_btn {
        width: 398px;
        text-align: center;
        line-height: 64px;
        height: 66px;
        border-radius: 41px;
        border: 1px solid #b0b0b0;
        margin: 0 auto;
        color: #999;
    }
}

.shPop {
    width: 410px;
    position: relative;

    .bj {
        width: 410px;
        height: auto;
        display: block;
    }

    .info {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
        top: 0;
        left: 0;
        padding: 57px 30px 0;

        .close {
            width: 20px;
            height: 20px;
            display: block;
            margin-left: auto;
            margin-right: 0;
            margin-bottom: 130px
        }
    }
}
.btn1 {
    line-height: 40px;
  padding: 0 20px;
  background: #1275FF;
  border-radius: 5px;
  margin: 0 10px;
  cursor: pointer;
  color: #fff;
}
.required_tips {
    width: 6px;
    height: 6px;
    display: block;
    border-radius: 50%;
    overflow: hidden;
    background: #eb3f25;
    margin-right: 8px;
    position: absolute;
    z-index: 2;
    left: 1px;
    top: 50%;
    transform: translateY(-50%);
}

</style>